export const RECAPTCHA_ACTIONS = {
    contact: "contact_form_submit",
    newsletter: "newsletter_submit",
    hubspot: "hubspot_form_submit",
} as const;
